import { Grid, Typography } from '@mui/material';
import React from 'react';
import { injectIntl } from 'react-intl';
import SelectButtonGroup from '../../../../components/SelectButtonGroup/SelectButtonGroup';
import { ADD_ONS_OPTIONS } from '../../../../constants/policy';
import { getAddOnsIntlId } from '../../../../utils/policy';

const AddOnsInput = props => {
  const { intl, value, onChange } = props;

  return (
    <Grid
      container
      spacing={0}
      sx={{
        justifyContent: "space-between",
        alignItems: "flex-start"
      }}>
      <Grid size={12}>
        <Typography color="textSecondary" style={{ whiteSpace: 'nowrap' }}>
          {intl.formatMessage({ id: 'add-ons' })}
        </Typography>
      </Grid>
      <Grid size={12}>
        <SelectButtonGroup
          value={value}
          choices={Object.values(ADD_ONS_OPTIONS).map(choice => ({
            value: choice,
            label: intl.formatMessage({ id: getAddOnsIntlId(choice) }),
            xs: 6,
            fullWidth: true
          }))}
          onChange={onChange}
          sx={{ justifyContent: "flex-end" }}
          buttonClassName="plan-type-select-button"
          multi={true}
        />
      </Grid>
    </Grid>
  );
};

export default injectIntl(AddOnsInput);
